import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import React from 'react';
import TextField from '@material-ui/core/TextField';
import { Tooltip, Grid } from '@material-ui/core';
import { Cancel, MailSharp } from '@material-ui/icons';
import 'CSS/demand-supply/demand-supply.scss';
import 'CSS/main.scss';

import {
  editProject,
  saveProject,
  getUsersInvited,
  inviteToProject,
  deleteUserFromProject,
} from 'Actions/projectActions';
import { connect } from 'react-redux';
import Divider from '@material-ui/core/Divider';
import { Chip } from '@material-ui/core';
import Downshift from 'downshift';
import keycode from 'keycode';
import AvatarUser from 'Demand/components/AvatarUser';
import ScrollArea from 'react-scrollbar';
import axios from 'Axios';
import Snackbar from 'ServerErrorSnackbar';

class ShareProjectDialog extends React.Component {
  state = {
    inputValue: '',
    selectedItem: [],
    shownString: '',
    users: [],
    SnackbarOpen: false,
    SnackbarMsg: false,
  };

  componentDidMount() {
    if (this.props.users) {
      this.setState({
        users: this.props.users,
      });
    }
  }

  componentDidUpdate(props, state) {
    if (
      (this.props.open !== props.open && props.open === false) ||
      this.props.currentProjectId !== props.currentProjectId
    ) {
      this.props.getUsersInvited(this.props.currentProjectId);
    }
  }
  sendReminder = (projectId, userId) => () => {
    axios
      .post('project/' + projectId + '/' + userId + '/remind')
      .then(response => {
        // if (response.data) {
        this.setState(
          {
            SnackbarMsg: 'The reminder email has been sent',
          },
          () => {
            this.handleOpenServerErrorSnackbar();
          }
        );
        // }
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        this.setState(
          {
            SnackbarMsg: errorMessage,
          },
          () => {
            this.handleOpenServerErrorSnackbar();
          }
        );
      });
  };

  handleCloseServerErrorSnackbar = () => {
    this.setState({ SnackbarOpen: false });
  };
  handleOpenServerErrorSnackbar = () => {
    this.setState({ SnackbarOpen: true });
  };
  handleEraseServerError = () => {
    this.setState({ SnackbarMsg: false });
  };

  renderInput = inputProps => {
    const { InputProps, classes, ref, ...other } = inputProps;

    return (
      <TextField
        multiline
        InputProps={{
          inputRef: ref,
          classes: {
            root: 'multilineField',
          },
          ...InputProps,
        }}
        {...other}
      />
    );
  };

  renderSuggestion = ({
    suggestion,
    index,
    itemProps,
    highlightedIndex,
    selectedItem,
  }) => {
    const isHighlighted = highlightedIndex === index;
    const isSelected = (selectedItem || '').indexOf(suggestion) > -1;

    return (
      <MenuItem
        {...itemProps}
        key={suggestion.userId}
        selected={isHighlighted}
        component="div"
        style={{
          fontWeight: isSelected ? 500 : 400,
        }}
      >
        {`${suggestion.firstName} ${suggestion.lastName}`}
      </MenuItem>
    );
  };

  getSuggestions = inputValue => {
    let count = 0;
    return this.props.users
      .filter(user => {
        if (
          (this.state.selectedItem.length === 0 ||
            this.state.selectedItem.find(
              selItem => selItem['userId'] === user.userId
            ) == null) &&
          this.props.usersInvited.find(
            selItem => selItem['userId'] === user.userId
          ) == null
        ) {
          return user;
        }
      })
      .filter(suggestion => {
        const keep =
          (!inputValue ||
            suggestion.firstName
              .toLowerCase()
              .includes(inputValue.toLowerCase()) ||
            suggestion.lastName
              .toLowerCase()
              .includes(inputValue.toLowerCase())) &&
          count < 5;

        if (keep) {
          count += 1;
        }

        return keep;
      });
  };
  handleKeyDown = event => {
    const { inputValue, selectedItem } = this.state;
    if (
      selectedItem.length &&
      !inputValue.length &&
      keycode(event) === 'backspace'
    ) {
      this.setState({
        selectedItem: selectedItem.slice(0, selectedItem.length - 1),
      });
    }
  };

  handleInputChange = event => {
    this.setState({ inputValue: event.target.value });
  };

  handleChange = item => {
    let { selectedItem } = this.state;

    if (!selectedItem.userId && selectedItem.userId != item.userId) {
      selectedItem = [...selectedItem, item];
    }

    this.setState({
      inputValue: '',
      selectedItem,
    });
  };
  handleClose = () => {
    this.setState({
      inputValue: '',
      selectedItem: [],
      shownString: '',
    });
    this.props.handleClose();
  };
  handleDelete = item => () => {
    let selectedItem = [...this.state.selectedItem];
    selectedItem = selectedItem.filter(sItem => {
      if (sItem.userId !== item.userId) {
        return sItem;
      }
    });

    this.setState({ selectedItem });
  };
  handleInviteToProject = (currentProjectId, userId) => {
    this.props.inviteToProject(currentProjectId, userId);
    this.setState({ selectedItem: [] });
  };

  onDataSend = () => {
    this.props.handleClose();
    this.handleInviteToProject(
      this.props.currentProjectId,
      this.state.selectedItem.map(user => user.userId)
    );
  };

  render() {
    const { inputValue, selectedItem } = this.state;
    return (
      <Dialog
        classes={{
          paper: 'e-zindex--max bc-gray share-dialog',
        }}
        maxWidth="xs"
        open={this.props.open ? this.props.open : false}
        onClose={this.handleClose}
        aria-labelledby="form-dialog-title"
      >
        <Cancel
          className="share-dialog__close-btn"
          onClick={this.handleClose}
        />
        <h2 className="t-primary-24 t-weight--b t-align-c u-mrg-top-50 u-mrg-bot-50 u-pad-r-25 u-pad-l-25">
          Invite colleagues to project
        </h2>
        <DialogContent
          classes={{
            root: 'shareDialogContent',
          }}
        >
          <div className="u-pad-r-25 u-pad-l-25">
            <p className="t-secondary-16 lh-24 t-align-c u-mrg-bot-50">
              Give full access to project (includes creating searches, inviting
              others, selecting luminaires etc.)
            </p>

            <Downshift
              inputValue={inputValue}
              onChange={this.handleChange}
              selectedItem={selectedItem}
              itemToString={item =>
                item ? `${item.firstName} ${item.lastName}` : ''
              }
            >
              {({
                getInputProps,
                getItemProps,
                isOpen,
                inputValue: inputValue2,
                selectedItem: selectedItem2,
                highlightedIndex,
              }) => (
                <div className="u-mrg-bot-30">
                  {this.renderInput({
                    fullWidth: true,
                    InputProps: getInputProps({
                      onChange: this.handleInputChange,
                      onKeyDown: this.handleKeyDown,
                      placeholder: 'Share with:',
                      id: 'integration-downshift-multiple',
                    }),
                  })}
                  {isOpen ? (
                    <Paper square className="e-zindex--max">
                      {this.getSuggestions(inputValue2).map(
                        (suggestion, index) =>
                          this.renderSuggestion({
                            suggestion,
                            index,
                            itemProps: getItemProps({ item: suggestion }),
                            highlightedIndex,
                            selectedItem: selectedItem2,
                          })
                      )}
                    </Paper>
                  ) : null}
                </div>
              )}
            </Downshift>
          </div>
          <Divider />
          <ScrollArea
            speed={0.8}
            className="scrollableShareBlock"
            contentClassName="content"
            horizontal={false}
          >
            <ul className="share-dialog__list">
              {selectedItem.map(item => (
                <li className="share-dialog__list-item" key={item.userId}>
                  <Grid alignItems="center" container spacing={16}>
                    <Grid item xs={6}>
                      <Chip
                        className="share-chip"
                        avatar={<AvatarUser user={item} />}
                        tabIndex={-1}
                        label={`${item.firstName} ${item.lastName}`}
                        classes={{
                          label: 'chip-label',
                        }}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <div className="share-dialog__share-status share-dialog__share-status--invited">
                        invited
                      </div>
                    </Grid>
                    <Grid item xs={2}>
                      <Cancel
                        className="share-dialog__delete-btn"
                        onClick={this.handleDelete(item)}
                      />
                    </Grid>
                  </Grid>
                </li>
              ))}
              {this.props.usersInvited &&
                this.props.usersInvited.map((user, index) => {
                  if (user.state === 'ACTIVE') {
                    return (
                      <li className="share-dialog__list-item" key={user.userId}>
                        <Grid alignItems="center" container spacing={16}>
                          <Grid item xs={6}>
                            <Chip
                              className="share-chip"
                              avatar={<AvatarUser user={user} />}
                              tabIndex={-1}
                              label={`${user.firstName} ${user.lastName}`}
                              classes={{
                                label: 'chip-label',
                              }}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            {this.props.usersInvited[index].creator ? (
                              <div className="share-dialog__share-status share-dialog__share-status--creator">
                                creator
                              </div>
                            ) : (
                              <div className="share-dialog__share-status share-dialog__share-status--accepted">
                                accepted
                              </div>
                            )}
                          </Grid>
                        </Grid>
                      </li>
                    );
                  } else if (
                    user.state === 'DEACTIVATED_PERMANENTLY' ||
                    user.state === 'DEACTIVATED'
                  ) {
                    return (
                      <li className="share-dialog__list-item" key={user.userId}>
                        <Grid alignItems="center" container spacing={16}>
                          <Grid item xs={6}>
                            <Chip
                              className="share-chip"
                              avatar={<AvatarUser user={user} />}
                              tabIndex={-1}
                              label={`${user.firstName} ${user.lastName}`}
                              classes={{
                                label: 'chip-label',
                              }}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <div className="share-dialog__share-status share-dialog__share-status--creator">
                              DEACTIVATED
                            </div>
                          </Grid>
                        </Grid>
                      </li>
                    );
                  }
                  return (
                    <li key={user.userId} className="share-dialog__list-item">
                      <Grid alignItems="center" container spacing={16}>
                        <Grid item xs={6}>
                          <Chip
                            className="share-chip u-mrg-bot-10"
                            avatar={<AvatarUser user={user} />}
                            label={`${user.firstName} ${user.lastName}`}
                            classes={{
                              label: 'chip-label',
                            }}
                          />
                        </Grid>

                        {user.state === 'PENDING' ? (
                          <React.Fragment>
                            <Grid item xs={4}>
                              <div className="share-dialog__share-status share-dialog__share-status--pending">
                                pending
                              </div>
                            </Grid>
                            <Grid item xs={2}>
                              <Tooltip title="Cancel invitation">
                                <Cancel
                                  className="share-dialog__delete-btn"
                                  onClick={this.props.deleteUserFromProject(
                                    this.props.currentProjectId,
                                    user.userId
                                  )}
                                />
                              </Tooltip>
                              <Tooltip title="Send reminder">
                                <MailSharp
                                  className="share-dialog__reminder-btn"
                                  onClick={this.sendReminder(
                                    this.props.currentProjectId,
                                    user.userId
                                  )}
                                />
                              </Tooltip>
                            </Grid>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <Grid item xs={4}>
                              <div className="share-dialog__share-status share-dialog__share-status--pending colorRedImp">
                                declined
                              </div>
                            </Grid>
                            <Grid item xs={2}>
                              <Tooltip title="Delete invitation">
                                <Cancel
                                  className="share-dialog__delete-btn"
                                  onClick={this.props.deleteUserFromProject(
                                    this.props.currentProjectId,
                                    user.userId
                                  )}
                                />
                              </Tooltip>
                            </Grid>
                          </React.Fragment>
                        )}
                      </Grid>
                    </li>
                  );
                })}
            </ul>
          </ScrollArea>
          <Divider className="u-mrg-bot-20" />
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={this.props.handleClose}>Cancel</Button> */}
          <Button
            onClick={this.onDataSend}
            variant="contained"
            color="primary"
            disabled={this.state.selectedItem.length === 0}
          >
            Done
          </Button>
        </DialogActions>
        <Snackbar
          open={this.state.SnackbarOpen}
          message={this.state.SnackbarMsg}
          onClose={this.handleCloseServerErrorSnackbar}
          handleEraseServerError={this.handleEraseServerError}
        />
      </Dialog>
    );
  }
}

const mapStateToProps = store => {
  return {
    users: store.initialData.users,
    usersInvited: store.projects.usersInvited,
    currentUser: store.user.user.userId,
  };
};
const mapDispatchToProps = dispatch => ({
  inviteToProject: (projectId, userArray) => {
    dispatch(inviteToProject(projectId, userArray));
  },
  editProject: (projectId, projectObject) => {
    dispatch(editProject(projectId, projectObject));
  },
  saveProject: projectObject => {
    dispatch(saveProject(projectObject));
  },
  getUsersInvited: projectId => {
    dispatch(getUsersInvited(projectId));
  },
  deleteUserFromProject: (projectId, userId) => () => {
    dispatch(deleteUserFromProject(projectId, userId));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(ShareProjectDialog);
